import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { IConfigurationResponse, IDashboardMidwifePayload, IDashboardMidwifeResponse, IPlace, IService } from 'src/app/models/dashboard.models';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HomeService } from 'src/app/services/home.service';
import { EditProfileService } from 'src/app/services/edit-profile.service';
import { IGenericResponse } from 'src/app/models/shared.models';
import { ImageUploadComponent } from '../shared-components/image-upload/image-upload.component';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { countryCodes } from 'src/app/constants/country';
import { environment } from 'src/environments/environment';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent implements OnInit {

  screen = 1;
  eye : boolean = true;
  languages:Array<string>=[];
  ethnicities: Array<string> = [];
  specialities: Array<string> = [];
  experiences: Array<number> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  @ViewChild("pass") pass: ElementRef;
  midwife: IDashboardMidwifePayload;
  midwifeId: any;
  pictureUrl: any = '';

  areas: IService[] = [];
  subAreas: IService[] = [];
  selectedArea = new FormControl();

  specialized = new FormControl([]);
  languageCtrl = new FormControl([]);
  serviceCtrl = new FormControl([]);
  myControl = new FormControl();
  options: string[] = [];
  filteredOptions: Observable<string[]>;

  photoBlog: any;
  loading: boolean = false;
  countries = countryCodes.countries;

  profileForm = new FormGroup({
    name: new FormControl('', Validators.required),
    userEmail: new FormControl('', Validators.required),
    userPhonenumber: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(13)]),
    countryCode: new FormControl('', Validators.required),
    alternatePhone: new FormControl('', [Validators.minLength(10), Validators.maxLength(18)]),
    address: new FormControl('', Validators.required),
    ethnicity: new FormControl('', Validators.required),
    languages: new FormControl('', Validators.required),
    intro: new FormControl('',Validators.required),
    speciality: new FormControl('', Validators.required),
    serviceAreas: new FormControl('', Validators.required),
    experienceInYears: new FormControl('', Validators.required),
    practiceId: new FormControl('', Validators.required),
    newPassword: new FormControl('', Validators.minLength(6)),
  });

  @ViewChild(ImageUploadComponent) cameraComponent: ImageUploadComponent;
  @ViewChild('selectLanguageEdit') selectLanguage: MatSelect;
  @ViewChild('selectAreasEdit') selectAreas: MatSelect;
  @ViewChild('selectSpecializedEdit') selectSpecialized: MatSelect;

  allSelectedLanguage = false;
  allSelectedAreas = false;
  allSelectedSpecialized = false;

  constructor(public authService: AuthService,
    public dashboardService: DashboardService,
    private homeService: HomeService,
    private editProfileService: EditProfileService,
    private snackBarService: SnackbarService) { }

  ngOnInit(): void {
    this.midwifeId = this.authService.getMidwifeId();
    this.getDropdownConfigurations();
    this.getMidwifeDetail();
    this.countries.forEach(country => {
      country.flag = environment.countryFlagUrl + country.code.toLowerCase() + '.svg';
    });

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this.searchPlace(value)),
    );
  }

  selectArea(value: any){
    this.profileForm.controls.address.setValue(value);
  }

  searchPlace(searchText: string): Array<string>{
    var body = {
      searchText: searchText
    }
    this.options = [];
    var sample: Array<string> = [];
    this.editProfileService.getPlaceSearchResults(body)
    .subscribe((res: Array<IPlace>)=>{
      console.log("Search Places:", res);
      res.forEach(place =>{ sample.push(place.description)});
    },err=>{
      console.error("Search Places Error:", err);
    });
    this.options = sample;
    return this.options;
  }

  getMidwifeDetail(): void{
    this.dashboardService.getMidwifeById(this.midwifeId)
    .subscribe((res: IDashboardMidwifeResponse)=>{
      this.midwife = res.payload;
      console.log("Midwife Detail:", this.midwife);
      this.setProfile(this.midwife.profileImage);
      this.setData();
    },err=>{
      console.error("Fetch Midwife Error:", err);
    });
  }

  toggle(option:string): void {
    this.eye = !this.eye;
    this.pass.nativeElement.type = this.eye ? "password" : "text";
  }

  setProfile(image: any): void{
    this.pictureUrl = image;
  }

  removeProfile(): void{
    this.pictureUrl = '';
  }

  setData(): void{
    this.profileForm.controls.name.setValue(this.midwife.name);
    this.profileForm.controls.userEmail.setValue(this.midwife.user[0].userEmail);
    this.profileForm.controls.userPhonenumber.setValue(this.midwife.user[0].userPhonenumber);
    this.profileForm.controls.countryCode.setValue('+' + this.midwife.user[0].countryCode);
    this.profileForm.controls.alternatePhone.setValue(this.midwife?.alternatePhone);
    this.profileForm.controls.address.setValue(this.midwife.address);
    this.myControl.setValue(this.midwife.address);
    this.profileForm.controls.intro.setValue(this.midwife.intro);
    this.profileForm.controls.practiceId.setValue(this.midwife.practiceId);
    this.profileForm.controls.practiceId.disable();
    this.profileForm.controls.ethnicity.setValue(this.midwife.ethnicity);
    this.profileForm.controls.speciality.setValue(this.midwife.speciality);
    this.profileForm.controls.experienceInYears.setValue(this.midwife.experienceInYears);
    this.profileForm.controls.serviceAreas.setValue(String(this.midwife.serviceAreas));
    this.profileForm.controls.languages.setValue(String(this.midwife.languages));
    this.languageCtrl.setValue(this.midwife.languages.split(","));
    this.serviceCtrl.setValue(this.midwife.serviceAreas.split(","));
    this.specialized.setValue(this.midwife.speciality.split(','));
  }

  getDropdownConfigurations(): void{
    this.ethnicities = [];
    this.specialities = [];
    this.languages = [];
    this.areas = [];
    this.homeService.getMiscConfiguration()
    .subscribe((res: IConfigurationResponse)=>{
      res.payload.ethnicities.forEach(ethnicitie => this.ethnicities.push(ethnicitie.name));
      res.payload.specialities.forEach(specialitie => this.specialities.push(specialitie.name));
      res.payload.languages.forEach(language => this.languages.push(language.name));
      this.areas = res.payload.serviceAreas;
      this.selectedArea.setValue(this.areas[0]);
      this.areas.forEach(area=>{
        this.subAreas = this.subAreas.concat(area.childAreas);
      });
    },err=>{
      console.error('Dropdown detail Error:',err);
    });
  }

  updateProfile(): void{
    this.loading = true;
    this.profileForm.controls.speciality.setValue(String(this.specialized.value[0]==0 ? this.specialized.value.slice(1) : this.specialized.value));
    this.profileForm.controls.languages.setValue(String(this.languageCtrl.value[0]==0 ? this.languageCtrl.value.slice(1) : this.languageCtrl.value));
    this.profileForm.controls.serviceAreas.setValue(String(this.serviceCtrl.value[0]==0 ? this.serviceCtrl.value.slice(1) : this.serviceCtrl.value));
    let body = this.profileForm.value;

    if(body['newPassword'].length == 0){
      delete body['newPassword'];
    }
    body.countryCode = body.countryCode.slice(1);
    this.editProfileService.updateProfileDetailMidwife(body)
    .subscribe((res: IDashboardMidwifeResponse)=>{
      console.log('Profile Updated :', res.payload);
      this.loading = false;
    },err=>{
      console.error('Profile Update Error:', err);
      this.loading = false;
    });

    if(this.pictureUrl && this.pictureUrl != this.midwife.profileImage)
    {
      this.loading = true;
      this.getBlob(this.pictureUrl).then(()=>{
        const frmData = new FormData();
        frmData.append('file', this.photoBlog, this.midwife.name+'.png');
        this.editProfileService.updateProfileImageMidwife(frmData)
        .subscribe((res: IGenericResponse)=>{
          console.log("Profile Photo Updated !");
          this.loading = false;
        },err=>{
          console.error("Profile Photo Update Error:", err);
          this.snackBarService.openSnackBar(err.error.errorMessage, null, 'top');
          this.loading = false;
        });
      });
    }
  }

  getBlob(url: any): Promise<any>{
    return fetch(url)
    .then(res => res.blob())
    .then(res=>{ this.photoBlog = res});
  }

  openModal(type: string){
    if(type=="camera")
    {
      this.cameraComponent.webCamInit();
      this.cameraComponent.showCamera = true;
    }
    else if(type=="upload"){
      this.cameraComponent.showCamera = false;
    }
  }

  closeDropdown(){
    if(this.screen == 1)
    {
      this.selectLanguage.close();
    }
    else{
      this.selectAreas.close();
      this.selectSpecialized.close();
    }
  }

  toggleAllSelection(type: string) {
    if(type == 'Language'){
      this.allSelectedLanguage = !this.allSelectedLanguage;
      if (this.allSelectedLanguage) {
        this.selectLanguage.options.forEach( (item : MatOption) => item.select());
      } else {
        this.selectLanguage.options.forEach( (item : MatOption) => {item.deselect()});
      }
    }
    else if(type == 'Area'){
      this.allSelectedAreas = !this.allSelectedAreas;
      if (this.allSelectedAreas) {
        this.selectAreas.options.forEach( (item : MatOption) => item.select());
      } else {
        this.selectAreas.options.forEach( (item : MatOption) => {item.deselect()});
      }
    }
    else if(type == 'Specialized'){
      this.allSelectedSpecialized = !this.allSelectedSpecialized;
      if (this.allSelectedSpecialized) {
        this.selectSpecialized.options.forEach( (item : MatOption) => item.select());
      } else {
        this.selectSpecialized.options.forEach( (item : MatOption) => {item.deselect()});
      }
    }
  }

}
